import { render, staticRenderFns } from "./loyaltySmartMomentCard.vue?vue&type=template&id=10c20e40&"
import script from "./loyaltySmartMomentCard.vue?vue&type=script&lang=js&"
export * from "./loyaltySmartMomentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports